import { SearchResultsExecutionStatusEnums } from '@as-react/common-types';
import { getNbrOfItemsInListerRow } from './ScreenWidthUtil';
import { NUMBER_OF_ITEMS_IN_LISTER_ROW_DESKTOP } from '../constants/ScreenWidthConstants';
import { MAX_NUMBER_OF_ARTICLES_IN_LISTER_PAGE_DEFAULT } from '../constants/ProductConstants';
/*
 * returns the exact nbr of items to fit in the lister window
 * such that at the end of the last row there aren't any empty product tiles
 */
export const getListerItemsToShow = (items, pageSize, isClient) => {
    const numberOfItemsInRow = isClient ? getNbrOfItemsInListerRow() : NUMBER_OF_ITEMS_IN_LISTER_ROW_DESKTOP;
    if (items.length > (pageSize || MAX_NUMBER_OF_ARTICLES_IN_LISTER_PAGE_DEFAULT)) {
        return items.slice(0, items.length - (items.length % numberOfItemsInRow));
    }
    else {
        return items;
    }
};
export const isPartialSearchResult = (executionStatus) => executionStatus === SearchResultsExecutionStatusEnums.ALT_BRAND ||
    executionStatus === SearchResultsExecutionStatusEnums.ALT_QUERIES ||
    executionStatus === SearchResultsExecutionStatusEnums.ALT_SPELL_UNCHANGED;
